import { useCallback, useMemo } from 'react';

/*
 * Borrador de quien responde: lo escrito sobrevive a cerrar la pestaña o a que se vaya la luz.
 * Vive en localStorage del navegador (no en el servidor: quien responde casi nunca tiene cuenta)
 * y caduca a los 30 días para no dejar formularios a medias para siempre.
 */
const CADUCA_MS = 30 * 24 * 60 * 60 * 1000;

export default function useBorrador(token, activo) {
  const clave = token ? `orvian_form_borrador:${token}` : null;

  const leer = useCallback(() => {
    if (!activo || !clave) return null;
    try {
      const d = JSON.parse(localStorage.getItem(clave) || 'null');
      if (!d || !d.t || Date.now() - d.t > CADUCA_MS) return null;
      return d;
    } catch {
      return null;
    }
  }, [activo, clave]);

  const guardar = useCallback((datos) => {
    if (!activo || !clave) return;
    try {
      localStorage.setItem(clave, JSON.stringify({ ...datos, t: Date.now() }));
    } catch {
      /* almacenamiento lleno o bloqueado: el formulario sigue funcionando sin borrador */
    }
  }, [activo, clave]);

  const borrar = useCallback(() => {
    if (!clave) return;
    try {
      localStorage.removeItem(clave);
    } catch {
      /* nada que borrar */
    }
  }, [clave]);

  return useMemo(() => ({ leer, guardar, borrar }), [leer, guardar, borrar]);
}
